import { ActionType } from 'typesafe-actions';
import * as helpCenterAction from './helpCenter';

export const CONTACTFORM_ACTION_PREFIX = 'CONTACTFORM_SUBMIT';

export const helpCenterActions = { ...helpCenterAction };

export type HelpCenterActions = ActionType<typeof helpCenterAction>;
